<template>
  <div class="dropdown-with-search">
    <model-select 
      :options="options"
      v-model="selected"
      :placeholder="label"
      :class="inputClasses"
      @input="onInputChanged"
      >
    </model-select>
  </div>
</template>

<script>
import { ModelSelect } from 'vue-search-select'
import { inputClassList } from '@/mixins/inputClassList.js'

export default {
  name: 'dropdown-with-search',
  mixins: [inputClassList],
  components: {
    ModelSelect
  },
  data() {
    return {
      selected: null
    }
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    inputKey: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      type: String
    },
    isValidField: {
      type: Boolean,
      required: false,
      default: true
    },
    isRecommendedField: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  mounted() {
    if (this.value) {
      this.selected = this.value + ""
    }
  },
  methods: {
    onInputChanged(event) {
      this.$emit('inputChanged', event)
    }
  }
}
</script>

<style scoped>
/*** Component Style ***/
.dropdown-with-search {
  position: relative;
}

.dropdown .dropdown-input {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
}
</style>